export const backendUrl = 'https://api.tickitz.rpratama.web.id'
